import type {z} from "zod";

import {EditSupplierNoteBody} from "@project/sdk/engineering/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const editSupplierNoteTitleSchema = requiredStringSchema(
  EditSupplierNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const editSupplierNoteContentSchema = requiredStringSchema(
  EditSupplierNoteBody.shape.content,
  noteFieldLabelIds.content,
);

export const editSupplierNoteFormSchema = EditSupplierNoteBody.extend({
  title: editSupplierNoteTitleSchema,
  content: editSupplierNoteContentSchema,
});
export type EditSupplierNoteFormPayload = z.output<typeof editSupplierNoteFormSchema>;

export const draftEditSupplierNoteFormSchema = editSupplierNoteFormSchema.partial();
export type DraftEditSupplierNoteFormPayload = z.output<typeof draftEditSupplierNoteFormSchema>;
